export default "__VITE_ASSET__YmMBMf60__"